
<template>
<div>
  <chc-header :noLogin="true"></chc-header>
  <navbar :noLogin="true"></navbar>
  <section v-if="!data.goodToken">
    <div class="field">
      Error, invalid or expired link. Please contact Cars Helping Charities to resend you tax documents.
    </div>
  </section>
  <section v-if="data.goodToken && !data.verified">
    <div class="field">
      <h1>Tax Document Portal</h1>
      <p>Please enter the following information to access your tax document</p>
      <chc-input v-model="data.first_name" label="First Name" :required="true"></chc-input>
      <chc-input v-model="data.last_name" label="Last Name" :required="true"></chc-input>
      <chc-input v-model="data.ssn_tax_id" label="SSN or Tax Id" :required="true" type="password"></chc-input>
      <span class="error-message" v-if="data.hasVerificationErrors">Invalid Credentials</span>
    </div>
    <div class="field buttons">
      <input type="submit" class="btn" value="Verify" @click="login">
    </div>
  </section>
  <section v-if="data.goodToken && data.verified">
    <div class="field">
      <h1>Tax Document Download File</h1>
      <a :href="data.downloadLink" :download="data.filename"><span class="icon fal fa-file-pdf" aria-hidden="true"></span> Download 1098</a>
    </div>
  </section>
</div>
</template>

<script>
import ChcHeader from '@/components/ChcHeader'
import Navbar from '@/components/Navbar'
import store from '@/store'

export default {
  name: 'FormPortal',
  data () {
    return {
      data: {
        goodToken: false,
        verified: false,
        hasVerificationErrors: false,

        downloadLink: '',
        filename: '1098.pdf',
      }
    }
  },
  props: [],
  beforeRouteEnter (to, from, next) {
    store.functions.formportal.donorInitialLogin({token: to.params.token}, (response) => {
      next()
    }).then((response) => {
      next(vm => vm.setData(response.data, to.params.token))
    }).catch(() => {
      next()
    })
  },
  methods: {
    setData (data, token) {
      this.data.token = token
      this.data.goodToken = true
    },
    login () {
      store.functions.formportal.donorLogin(this.data, (err) => {
        this.data.hasVerificationErrors = true
        this.data.error = err
      }).then((response) => {
        this.data.verified = true
        this.data.hasVerificationErrors = false
        this.openAsDownload(response.data)
      })
    },
    openAsDownload (data, mime) {
      var blob = new Blob([data], {type: mime || 'application/octet-stream'})
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were
        // revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing
        // the URL has been freed."
        window.navigator.msSaveBlob(blob, this.data.filename)
      } else {
        var blobURL = window.URL.createObjectURL(blob)
        this.data.downloadLink = blobURL
      }
    },
  },
  components: {
    ChcHeader,
    Navbar
  }
}
</script>

<style scoped>
section {
    margin-top: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/Widgets/FormPortal.vue